import { Controller } from "@hotwired/stimulus"

export default class WalletFilter extends Controller {

  open(e) {
    e.preventDefault()
    this.popupTarget.classList.toggle("d-none")
  }

  load(e) {
    e.preventDefault()
    const url = e.currentTarget.dataset.url

    Turbo.visit(url, { frame: "wallet_transactions" })
  }

  range(from, to) {
    Turbo.visit(`?filter=range&from=${from}&to=${to}`, {
      frame: "wallet_transactions"
    })
  }
}
